import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { IconsService } from 'app/shared/services/Modal/icons.service';
import { AccountLevel, defaultAccount } from 'app/view/New-Finances/modules/account.interface';
import { AccountsTreeService } from 'app/view/New-Finances/services/accounts-tree.service';
import { GeneralFinanceService } from 'app/view/New-Finances/services/general-finance.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-shared-accordion',
  templateUrl: './shared-accordion.component.html',
  styleUrls: ['./shared-accordion.component.scss']
})
export class SharedAccordionComponent implements OnInit {

  // The input property to bind an item, initialized to 'defaultAccount'
  @Input() item: any = defaultAccount;
  // Indicates if this item is the main account. Default is null.
  @Input() isMain: boolean = null;
  // Indicates if this item is a any other main . Default is null.
  @Input() ForeginMain: boolean = null;
  // Controls whether additional UI controls (like buttons) should be displayed. Default is null.
  @Input() showControls: boolean = null;
  // @Input() showControls: {add:boolean,edit:boolean,delete:boolean} = null;

  // Allows an icon to be passed into the component, initialized to null.
  @Input() iconInput: any = null;
  // Determines whether to show the "Add" button. Default is false.
  @Input() viewAddButton: boolean = false;
  // Determines whether to show the "Edit" button. Default is false.
  @Input() viewEditButton: boolean = false;
  // Determines whether to show the "Delete" button. Default is false.
  @Input() viewDeleteButton: boolean = false;
  // routering to any path
  @Input() routeringPath: string = null;

  @Output() getData: EventEmitter<any> = new EventEmitter();

  @Output() viewData: EventEmitter<any> = new EventEmitter();

  @Output() openAddFun: EventEmitter<any> = new EventEmitter();

  @Output() editItemEvent: EventEmitter<any> = new EventEmitter();

  @Output() deleteItemEvent: EventEmitter<any> = new EventEmitter();

  Accordion_zIndex: number = 1;
  AccountLevel = AccountLevel
  // companyID: number = 0;
  lang: string;

  constructor(
    public icons: IconsService,
    private ngbModal: NgbModal,
    private _ActivatedRoute: ActivatedRoute,
    private _AccountService: AccountsTreeService,
    private _GeneralFinanceService:GeneralFinanceService,
    private toastr:ToastrService,
    private translateService:TranslateService,
  ) {
    // this._ActivatedRoute.paramMap.subscribe((param: any) => {
    //   this.companyID = +param.params['companyID'];
    // })
    if (JSON.parse(localStorage.getItem("lang_ERP")))
      this.lang = JSON.parse(localStorage.getItem("lang_ERP")).lang
    else
      this.lang = "ar"
  }

  ngOnInit(): void {
  }


  // Method to trigger an "add event" for the provided account ID
  openAdd(id: string) {
    // Emit the given ID using the AccessSharedAddEvent subject of the AccountService
    // This notifies subscribers about the "add event" along with the associated account ID
    this._GeneralFinanceService.AccessSharedAddEvent.next(id);
  }

  editItem(item:any){
    this.editItemEvent.emit(item)

  }

  deleteItem(item:any){
    this.deleteItemEvent.emit(item)
    // this._AccountService.deleteAccount(item.id).subscribe({
    //   next:(res:any)=> {this.toastr.success(res.message);this.getDataFun()},
    //   error:(res:any)=> {this.toastr.error(res.message)},
    // })
  }

  getDataFun(){
    this.getData.emit('')
  }
}
